import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import SelectProduto from 'app/components/Select/SelectProduto';
import { useFormikContext } from 'formik';
import React from 'react';


const ProdutoBuscaAvancadaForm = () => {
  const finalidades = [
    { id: 'MERCADORIA_REVENDA', title: '00 - Mercadoria para Revenda' },
    { id: 'MATERIA_PRIMA', title: '01 - Matéria-prima' },
    { id: 'EMBALAGEM', title: '02 - Embalagem' },
    { id: 'PRODUTO_EM_PROCESSO', title: '03 - Produto em Processo (produto semi-acabado)' },
    { id: 'PRODUTO_ACABADO', title: '04 - Produto Acabado' },
    { id: 'SUBPRODUTO', title: '05 - Subproduto' },
    { id: 'PRODUTO_INTERMEDIARIO', title: '06 - Produto Intermediário' },
    { id: 'MATERIAL_USO_CONSUMO', title: '07 - Material de Uso e Consumo' },
    { id: 'ATIVO_IMOBILIZADO', title: '08 - Ativo Imobilizado' },
    { id: 'SERVICOS', title: '09 - Serviços' },
    { id: 'OUTROS_INSUMOS', title: '10 - Outros insumos' },
    { id: 'OUTRAS', title: '99 - Outras' },
  ];

  const formik = useFormikContext();
  
  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectProduto
          id="nome"
          name="nome"
          label="Nome do produto"
          value={formik.values?.nome}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="codigo"
          name="codigo"
          label="Código do produto (SKU)"
          fullWidth
          variant="outlined"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.codigo}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectInput
          id="inativo"
          name="inativo"
          label="Situação"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.inativo}        
          options={[
              { id: 'FALSE', title: 'Ativo' },
              { id: 'TRUE', title: 'Inativo' },
            ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectInput
          id="tipoFinalidade"
          name="tipoFinalidade"
          label="Finalidade (Bloco K)"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.tipoFinalidade}
          options={finalidades}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              id="promocao"
              name="promocao"
              value={formik.values?.promocao}
              checked={formik.values?.promocao}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              size="small"
            />
          }
          label="Produto em promoção"
        />
      </Grid>
    
    </Grid>
  );
};

export default ProdutoBuscaAvancadaForm;